import styled, { keyframes } from "styled-components";

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  height: 100%;
`;

export const AboutHeader = styled.div`
  background: var(--surface);
  padding-top: 20px;
  margin-top: ${(props) => (props.$offMargin ? "0px" : "75px")};
  text-align: center;
  /* border-bottom: 2px solid var(--accent); */
  padding-bottom: 20px;

  h1 {
    font-size: 48px;
    font-weight: 700;
    /* margin-bottom: 20px; */
    text-transform: uppercase;
    letter-spacing: 2px;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  p {
    font-size: 16px;
    color: var(--text-muted);
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.8;
  }
  @media (max-width: 920px) {
    margin-top: ${(props) => (props.$offMargin ? "0px" : "66.7px")};
  }
`;

export const StorySection = styled.div`
  background: var(--secondary);
  width: 100%;
  border-radius: 30px;
  padding: 40px;
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const StoryContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: center;
  max-height: 100dvh;

  height: 100%;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 1050px) {
    flex-direction: column;
    max-height: 100%;
  }
`;

export const StoryText = styled.div`
  animation: ${slideInLeft} 1s ease-out;
  max-width: 55%;

  h2 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 30px;
    text-transform: uppercase;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 768px) {
      font-size: 32px;
    }
  }
  @media (max-width: 1050px) {
    max-width: 100%;
  }

  p {
    font-size: 16px;
    line-height: 1.8;
    color: var(--text-secondary);
    margin-bottom: 25px;
  }

  .highlight {
    font-weight: 600;
    color: var(--accent);
  }
`;

export const StoryImage = styled.img`
  background: var(--surface);
  height: 600px;
  width: 100%;
  object-fit: cover;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: none;
  animation: ${slideInLeft} 1s ease-out 0.3s both;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--gradient-primary);
    opacity: 0.05;
  }
`;

export const ImageCaption = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  text-align: center;
  color: var(--text-muted);
  font-weight: 500;
`;

export const ExperienceSection = styled.div`
  width: 100%;

  /* margin-bottom: -90px; */
`;

export const ExperienceGrid = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: row;
  padding: 40px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const ExperienceCard = styled.div`
  background: var(--surface);
  padding: 40px 30px;
  max-width: 400px;
  /* flex: 1; */
  width: 100%;
  border-radius: 25px;
  text-align: center;
  transition: all 0.3s ease;
  border: 2px solid var(--accent-light);
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-soft);
  animation: ${scaleIn} 0.6s ease forwards;
  animation-delay: ${(props) => props.$delay || 0}ms;
  opacity: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: var(--gradient-primary);
  }

  &:hover {
    transform: translateY(-10px);
    background: var(--surface);
  }

  .number {
    font-size: 48px;
    font-weight: 700;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 15px;
    display: block;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    margin-bottom: 10px;
    text-transform: uppercase;
    color: var(--text-primary);
  }

  p {
    color: var(--text-secondary);
    line-height: 1.6;
    font-size: 14px;
  }
`;

export const SkillsSection = styled.div`
  background: var(--secondary);
  padding: 40px;
  width: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const SkillsHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 20px;
    text-transform: uppercase;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 768px) {
      font-size: 32px;
    }
  }

  p {
    font-size: 16px;
    color: var(--text-secondary);
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.8;
  }
`;

export const SkillsGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 70rem;
  gap: 30px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

export const SkillCard = styled.div`
  background: var(--surface);
  padding: 35px 25px;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s ease;
  max-width: 280px;
  width: 100%;
  border: 2px solid var(--accent-light);
  position: relative;
  overflow: hidden;
  animation: ${fadeInUp} 0.6s ease forwards;
  animation-delay: ${(props) => props.$delay || 0}ms;
  opacity: 0;

  &:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-medium);
    border-color: var(--accent);
    background: var(--surface);
  }

  .icon {
    width: 60px;
    height: 60px;
    background: var(--gradient-primary);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    font-size: 24px;
    color: var(--surface);
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    text-transform: uppercase;
    color: var(--text-primary);
  }

  p {
    color: var(--text-secondary);
    line-height: 1.6;
    font-size: 14px;
  }
`;

export const CTASection = styled.div`
  position: relative;
  padding: 40px 80px;
  background: var(--surface);
  border-radius: 30px;
  width: 100%;
  border: 3px solid var(--accent-light);
  width: fit-content;
  overflow: hidden;
  align-self: center;
  margin: 40px 0px;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--accent);
    background: var(--surface);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: var(--gradient-primary);
  }
`;

export const CTAContent = styled.div`
  text-align: center;
  position: relative;
  z-index: 2;
`;

export const CTATitle = styled.h2`
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 20px;
  text-transform: uppercase;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const CTADescription = styled.p`
  font-size: 18px;
  color: var(--text-secondary);
  margin-bottom: 40px;
  line-height: 1.7;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
`;

export const CTAButtons = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const CTAButton = styled.button`
  background: ${(props) =>
    props.$primary ? "var(--gradient-primary)" : "transparent"};
  color: ${(props) => (props.$primary ? "var(--surface)" : "var(--accent)")};
  border: 2px solid
    ${(props) => (props.$primary ? "var(--accent)" : "var(--accent-light)")};
  padding: 18px 35px;
  border-radius: 30px;
  font-weight: 600;
  font-family: "Source Code Pro", monospace;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  transition:
    color 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease;

  display: inline-flex;
  align-items: center;
  gap: 12px;
  box-shadow: var(--shadow-soft);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: var(--shadow-medium);
    border-color: var(--accent);
    background: ${(props) =>
      props.$primary ? "var(--accent-dark)" : "var(--accent)"};
    color: var(--surface);

    &::before {
      left: 100%;
    }
  }
`;

export const CTAFeatures = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 30px;
    margin-top: 40px;
  }
`;

export const CTAFeature = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;

  svg {
    color: var(--accent);
    font-size: 16px;
  }
`;
